import React, {ReactNode, useEffect} from 'react'
import {ModifiUiApp} from '@modifi/ui'

import Navigation from './navigation'
import {hasAuthority} from '../constants/permissions'

type LayoutProps = {
  children: ReactNode
  fetchUser: () => void
}

const Layout: React.FC<LayoutProps> = ({children, fetchUser}) => {
  const hasHubAccess = hasAuthority('hub:read')

  useEffect(() => {
    if (hasHubAccess) {
      fetchUser()
    }
  }, [fetchUser, hasHubAccess])

  return (
    <ModifiUiApp>
      <Navigation>{children}</Navigation>
    </ModifiUiApp>
  )
}

export default Layout
